import * as React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppState } from '../core/redux/appState';
import { TextDirection } from './textDirection';
import { strictEquals } from '../language/module';


interface Props extends LinkProps {
  forceDirection?: TextDirection;
}


/**
 * LocalLink: a component that
 *
 * PureComponent: true
 * Redux Connected: false
 */
const LocalLink: React.FC<Props> = props => {
  const { forceDirection, ...rest } = props;

  const layoutDirection = useSelector<AppState, TextDirection>(
    state => state.locale.textDirection,
    strictEquals,
  );

  return (
    <Link {...rest} to={props.to} dir={forceDirection ?? layoutDirection}>
      {props.children}
    </Link>
  );
};

export default LocalLink;
